<main class="container layout-39">
  <div id="containerLeftMenu" style="margin-right: 15px">
    <left-menu />
  </div>
  <section id="column2">
    <div class="row">
      <div class="col col-12">

        <div class="stats-page-header mb-3">
          <h1 class="h4 mb-0 d-flex align-items-center">
            AI Statistics
          </h1>
        </div>

        <mat-tab-group [(selectedIndex)]="selectedTabIndex" (selectedTabChange)="onTabChange($event)" animationDuration="200ms">

          <!-- ════════════════════════════════════════════════════════════════
               TAB 0: Nora AI Chat
               ════════════════════════════════════════════════════════════════ -->
          <mat-tab>
            <ng-template mat-tab-label>
              Nora AI Chat
            </ng-template>

            <div class="tab-content-pad">

              @if (noraError) {
                <div class="alert alert-danger d-flex align-items-center gap-2 mt-3">
                  <mat-icon>error_outline</mat-icon> {{ noraError }}
                </div>
              }

              <!-- Filters -->
              <div class="card shadow-sm rounded-3 mb-4 mt-3">
                <div class="card-header stats-card-header py-2 px-3 d-flex align-items-center">
                  <mat-icon class="stats-header-icon me-2">filter_list</mat-icon>
                  <span>&nbsp;Filter</span>
                </div>
                <div class="card-body py-3 px-3">
                  <div class="stats-filter-row">
                    <div class="stats-filter-field">
                      <label class="stats-filter-label">Date From</label>
                      <input type="date" class="form-control form-control-sm" [(ngModel)]="noraDateFrom">
                    </div>
                    <div class="stats-filter-field">
                      <label class="stats-filter-label">Date To</label>
                      <input type="date" class="form-control form-control-sm" [(ngModel)]="noraDateTo">
                    </div>
                    <div class="stats-filter-actions">
                      <button class="btn btn-primary btn-sm no-arrow stats-filter-btn" (click)="applyNoraFilters()">
                        <mat-icon class="stats-btn-icon">search</mat-icon> Apply
                      </button>
                      <button class="btn btn-outline-secondary btn-sm no-arrow stats-filter-btn" (click)="clearNoraFilters()">
                        <mat-icon class="stats-btn-icon">close</mat-icon> Clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              @if (noraLoading) { <app-ai-statistics-skeleton></app-ai-statistics-skeleton> }

              @if (!noraLoading) {

                <!-- KPI Cards -->
                @if (noraAggregateStats) {
                  <div class="mb-4">

                    <!-- Row 1: Usage overview -->
                    <div class="kpi-section__label">Usage</div>
                    <div class="kpi-grid kpi-grid-4 mb-3">
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Conversations</div>
                          <div class="kpi-card__value kpi-blue">{{ noraAggregateStats.totalConversations | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-blue"><mat-icon>forum</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Total Queries</div>
                          <div class="kpi-card__value kpi-blue">{{ noraAggregateStats.totalQueries | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-blue"><mat-icon>question_answer</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Unique Users</div>
                          <div class="kpi-card__value kpi-blue">{{ noraAggregateStats.uniqueUsers | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-blue"><mat-icon>people</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Avg Tokens / Response</div>
                          <div class="kpi-card__value kpi-green">{{ noraAggregateStats.avgTokensPerResponse | number:'1.0-0' }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-green"><mat-icon>bolt</mat-icon></div>
                      </div>
                    </div>

                    <!-- Row 2: Token averages & peaks -->
                    <div class="kpi-section__label">Token Averages &amp; Peaks</div>
                    <div class="kpi-grid kpi-grid-4 mb-3">
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Avg Tokens / Chat</div>
                          <div class="kpi-card__value kpi-green">{{ noraAggregateStats.avgTokensPerChat | number:'1.0-0' }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-green"><mat-icon>chat_bubble</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Max Tokens / Response</div>
                          <div class="kpi-card__value kpi-orange">{{ noraAggregateStats.maxTokensPerResponse | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-orange"><mat-icon>trending_up</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Max Tokens / Chat</div>
                          <div class="kpi-card__value kpi-orange">{{ noraAggregateStats.maxTokensPerChat | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-orange"><mat-icon>bar_chart</mat-icon></div>
                      </div>
                    </div>

                    <!-- Row 3: Recent activity -->
                    <div class="kpi-section__label">Recent Activity</div>
                    <div class="kpi-grid kpi-grid-3">
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Tokens (last 24h)</div>
                          <div class="kpi-card__value kpi-purple">{{ noraAggregateStats.tokensLastDay | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-purple"><mat-icon>today</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Tokens (last 7 days)</div>
                          <div class="kpi-card__value kpi-purple">{{ noraAggregateStats.tokensLastWeek | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-purple"><mat-icon>date_range</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Tokens (last 30 days)</div>
                          <div class="kpi-card__value kpi-purple">{{ noraAggregateStats.tokensLastMonth | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-purple"><mat-icon>calendar_month</mat-icon></div>
                      </div>
                    </div>

                  </div>
                }

                <!-- Chat Sessions Grid -->
                <div class="card shadow-sm rounded-3 mb-4">
                  <div class="card-header stats-card-header py-2 px-3 d-flex align-items-center">
                    <mat-icon class="stats-header-icon me-2">table_chart</mat-icon>
                    <span>&nbsp;Chat Sessions</span>
                  </div>
                  <div class="card-body p-0">
                    <app-data-grid
                      [data]="noraSessions"
                      [columns]="noraColumns"
                      [config]="noraGridConfig"
                      [totalCount]="noraTotalCount"
                      [loading]="noraLoading"
                      (pageChanged)="onNoraPageChange($event)"
                      (columnFilterChanged)="onNoraColumnFilterChange($event)">
                    </app-data-grid>
                  </div>
                </div>

                <!-- Token Usage Chart -->
                @if (noraTokenUsageOverTime.length > 0) {
                  <div class="card shadow-sm rounded-3 mb-4">
                    <div class="card-header stats-card-header py-2 px-3 d-flex align-items-center">
                      <mat-icon class="stats-header-icon me-2">show_chart</mat-icon>
                      <span>&nbsp;Token Usage Over Time</span>
                    </div>
                    <div class="card-body p-3">
                      <div style="position: relative; height: 300px;">
                        <canvas #tokenChart></canvas>
                      </div>
                    </div>
                  </div>
                }

              }
            </div>
          </mat-tab>

          <!-- ════════════════════════════════════════════════════════════════
               TAB 1: AI Code Assessments
               ════════════════════════════════════════════════════════════════ -->
          <mat-tab>
            <ng-template mat-tab-label>
              Code Assessments
            </ng-template>

            <div class="tab-content-pad">

              @if (codeError) {
                <div class="alert alert-danger d-flex align-items-center gap-2 mt-3">
                  <mat-icon>error_outline</mat-icon> {{ codeError }}
                </div>
              }

              <!-- Filters -->
              <div class="card shadow-sm rounded-3 mb-4 mt-3">
                <div class="card-header stats-card-header py-2 px-3 d-flex align-items-center">
                  <mat-icon class="stats-header-icon me-2">filter_list</mat-icon>
                  <span>&nbsp;Filter</span>
                </div>
                <div class="card-body py-3 px-3">
                  <div class="stats-filter-row">
                    <div class="stats-filter-field">
                      <label class="stats-filter-label">Date From</label>
                      <input type="date" class="form-control form-control-sm" [(ngModel)]="codeDateFrom">
                    </div>
                    <div class="stats-filter-field">
                      <label class="stats-filter-label">Date To</label>
                      <input type="date" class="form-control form-control-sm" [(ngModel)]="codeDateTo">
                    </div>
                    <div class="stats-filter-actions">
                      <button class="btn btn-primary btn-sm no-arrow stats-filter-btn" (click)="applyCodeFilters()">
                        <mat-icon class="stats-btn-icon">search</mat-icon> Apply
                      </button>
                      <button class="btn btn-outline-secondary btn-sm no-arrow stats-filter-btn" (click)="clearCodeFilters()">
                        <mat-icon class="stats-btn-icon">close</mat-icon> Clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              @if (codeLoading) { <app-ai-statistics-skeleton></app-ai-statistics-skeleton> }

              @if (!codeLoading) {

                <!-- KPI Cards -->
                @if (codeAggregateStats) {
                  <div class="mb-4">

                    <!-- Row 1: Job summary -->
                    <div class="kpi-section__label">Job Summary</div>
                    <div class="kpi-grid kpi-grid-4 mb-3">
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Total Jobs</div>
                          <div class="kpi-card__value kpi-blue">{{ codeAggregateStats.totalJobs | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-blue"><mat-icon>work</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Completed</div>
                          <div class="kpi-card__value kpi-green">{{ codeAggregateStats.completedJobs | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-green"><mat-icon>check_circle</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Failed</div>
                          <div class="kpi-card__value kpi-red">{{ codeAggregateStats.failedJobs | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-red"><mat-icon>error</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Unique Users</div>
                          <div class="kpi-card__value kpi-blue">{{ codeAggregateStats.uniqueUsers | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-blue"><mat-icon>people</mat-icon></div>
                      </div>
                    </div>

                    <!-- Row 2: Token totals & averages -->
                    <div class="kpi-section__label">Token Usage</div>
                    <div class="kpi-grid kpi-grid-4 mb-3">
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Total Prompt Tokens</div>
                          <div class="kpi-card__value kpi-purple">{{ codeAggregateStats.totalPromptTokens | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-purple"><mat-icon>input</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Total Completion Tokens</div>
                          <div class="kpi-card__value kpi-purple">{{ codeAggregateStats.totalCompletionTokens | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-purple"><mat-icon>output</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Avg Tokens / Job</div>
                          <div class="kpi-card__value kpi-green">{{ codeAggregateStats.avgTokensPerJob | number:'1.0-0' }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-green"><mat-icon>bolt</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Max Tokens / Job</div>
                          <div class="kpi-card__value kpi-orange">{{ codeAggregateStats.maxTokensPerJob | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-orange"><mat-icon>trending_up</mat-icon></div>
                      </div>
                    </div>

                    <!-- Row 3: Recent activity -->
                    <div class="kpi-section__label">Recent Activity</div>
                    <div class="kpi-grid kpi-grid-3">
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Tokens (last 24h)</div>
                          <div class="kpi-card__value kpi-purple">{{ codeAggregateStats.tokensLastDay | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-purple"><mat-icon>today</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Tokens (last 7 days)</div>
                          <div class="kpi-card__value kpi-purple">{{ codeAggregateStats.tokensLastWeek | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-purple"><mat-icon>date_range</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Tokens (last 30 days)</div>
                          <div class="kpi-card__value kpi-purple">{{ codeAggregateStats.tokensLastMonth | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-purple"><mat-icon>calendar_month</mat-icon></div>
                      </div>
                    </div>

                  </div>
                }

                <!-- Jobs Grid -->
                <div class="card shadow-sm rounded-3 mb-4">
                  <div class="card-header stats-card-header py-2 px-3 d-flex align-items-center">
                    <mat-icon class="stats-header-icon me-2">table_chart</mat-icon>
                    <span>&nbsp;Assessment Jobs</span>
                  </div>
                  <div class="card-body p-0">
                    <app-data-grid
                      [data]="codeJobs"
                      [columns]="codeColumns"
                      [config]="codeGridConfig"
                      [totalCount]="codeTotalCount"
                      [loading]="codeLoading"
                      (pageChanged)="onCodePageChange($event)">
                    </app-data-grid>
                  </div>
                </div>

                <!-- Token Usage Chart -->
                @if (codeTokenUsageOverTime.length > 0) {
                  <div class="card shadow-sm rounded-3 mb-4">
                    <div class="card-header stats-card-header py-2 px-3 d-flex align-items-center">
                      <mat-icon class="stats-header-icon me-2">show_chart</mat-icon>
                      <span>&nbsp;Token Usage Over Time</span>
                    </div>
                    <div class="card-body p-3">
                      <div style="position: relative; height: 300px;">
                        <canvas #codeAssessmentChart></canvas>
                      </div>
                    </div>
                  </div>
                }

              }
            </div>
          </mat-tab>

          <!-- ════════════════════════════════════════════════════════════════
               TAB 2: CMDB Readiness Scoring
               ════════════════════════════════════════════════════════════════ -->
          <mat-tab>
            <ng-template mat-tab-label>
              CMDB Readiness Scoring
            </ng-template>

            <div class="tab-content-pad">

              @if (cmdbError) {
                <div class="alert alert-danger d-flex align-items-center gap-2 mt-3">
                  <mat-icon>error_outline</mat-icon> {{ cmdbError }}
                </div>
              }

              <!-- Filters -->
              <div class="card shadow-sm rounded-3 mb-4 mt-3">
                <div class="card-header stats-card-header py-2 px-3 d-flex align-items-center">
                  <mat-icon class="stats-header-icon me-2">filter_list</mat-icon>
                  <span>&nbsp;Filter</span>
                </div>
                <div class="card-body py-3 px-3">
                  <div class="stats-filter-row">
                    <div class="stats-filter-field">
                      <label class="stats-filter-label">Date From</label>
                      <input type="date" class="form-control form-control-sm" [(ngModel)]="cmdbDateFrom">
                    </div>
                    <div class="stats-filter-field">
                      <label class="stats-filter-label">Date To</label>
                      <input type="date" class="form-control form-control-sm" [(ngModel)]="cmdbDateTo">
                    </div>
                    <div class="stats-filter-actions">
                      <button class="btn btn-primary btn-sm no-arrow stats-filter-btn" (click)="applyCmdbFilters()">
                        <mat-icon class="stats-btn-icon">search</mat-icon> Apply
                      </button>
                      <button class="btn btn-outline-secondary btn-sm no-arrow stats-filter-btn" (click)="clearCmdbFilters()">
                        <mat-icon class="stats-btn-icon">close</mat-icon> Clear
                      </button>
                    </div>
                  </div>
                </div>
              </div>

              @if (cmdbLoading) { <app-ai-statistics-skeleton></app-ai-statistics-skeleton> }

              @if (!cmdbLoading) {

                <!-- KPI Cards -->
                @if (cmdbAggregateStats) {
                  <div class="mb-4">

                    <!-- Row 1: Job summary -->
                    <div class="kpi-section__label">Job Summary</div>
                    <div class="kpi-grid kpi-grid-4 mb-3">
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Total Jobs</div>
                          <div class="kpi-card__value kpi-blue">{{ cmdbAggregateStats.totalJobs | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-blue"><mat-icon>work</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Completed</div>
                          <div class="kpi-card__value kpi-green">{{ cmdbAggregateStats.completedJobs | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-green"><mat-icon>check_circle</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Failed</div>
                          <div class="kpi-card__value kpi-red">{{ cmdbAggregateStats.failedJobs | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-red"><mat-icon>error</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Apps Processed</div>
                          <div class="kpi-card__value kpi-blue">{{ cmdbAggregateStats.totalApplicationsProcessed | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-blue"><mat-icon>apps</mat-icon></div>
                      </div>
                    </div>

                    <!-- Row 2: Token usage -->
                    <div class="kpi-section__label">Token Usage</div>
                    <div class="kpi-grid kpi-grid-4 mb-3">
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Total Prompt Tokens</div>
                          <div class="kpi-card__value kpi-purple">{{ cmdbAggregateStats.totalPromptTokens | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-purple"><mat-icon>input</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Total Completion Tokens</div>
                          <div class="kpi-card__value kpi-purple">{{ cmdbAggregateStats.totalCompletionTokens | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-purple"><mat-icon>output</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Avg Tokens / Job</div>
                          <div class="kpi-card__value kpi-green">{{ cmdbAggregateStats.avgTokensPerJob | number:'1.0-0' }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-green"><mat-icon>bolt</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Avg Tokens / App</div>
                          <div class="kpi-card__value kpi-green">{{ cmdbAggregateStats.avgTokensPerApp | number:'1.0-0' }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-green"><mat-icon>memory</mat-icon></div>
                      </div>
                    </div>

                    <!-- Row 3: Recent activity -->
                    <div class="kpi-section__label">Recent Activity</div>
                    <div class="kpi-grid kpi-grid-4">
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Max Tokens / Job</div>
                          <div class="kpi-card__value kpi-orange">{{ cmdbAggregateStats.maxTokensPerJob | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-orange"><mat-icon>trending_up</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Tokens (last 24h)</div>
                          <div class="kpi-card__value kpi-purple">{{ cmdbAggregateStats.tokensLastDay | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-purple"><mat-icon>today</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Tokens (last 7 days)</div>
                          <div class="kpi-card__value kpi-purple">{{ cmdbAggregateStats.tokensLastWeek | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-purple"><mat-icon>date_range</mat-icon></div>
                      </div>
                      <div class="kpi-card">
                        <div class="kpi-card__content">
                          <div class="kpi-card__label">Tokens (last 30 days)</div>
                          <div class="kpi-card__value kpi-purple">{{ cmdbAggregateStats.tokensLastMonth | number }}</div>
                        </div>
                        <div class="kpi-card__icon kpi-purple"><mat-icon>calendar_month</mat-icon></div>
                      </div>
                    </div>

                  </div>
                }

                <!-- Jobs Grid -->
                <div class="card shadow-sm rounded-3 mb-4">
                  <div class="card-header stats-card-header py-2 px-3 d-flex align-items-center">
                    <mat-icon class="stats-header-icon me-2">table_chart</mat-icon>
                    <span>&nbsp;Readiness Scoring Jobs</span>
                  </div>
                  <div class="card-body p-0">
                    <app-data-grid
                      [data]="cmdbJobs"
                      [columns]="cmdbColumns"
                      [config]="cmdbGridConfig"
                      [totalCount]="cmdbTotalCount"
                      [loading]="cmdbLoading"
                      (pageChanged)="onCmdbPageChange($event)">
                    </app-data-grid>
                  </div>
                </div>

                <!-- Token Usage Chart -->
                @if (cmdbTokenUsageOverTime.length > 0) {
                  <div class="card shadow-sm rounded-3 mb-4">
                    <div class="card-header stats-card-header py-2 px-3 d-flex align-items-center">
                      <mat-icon class="stats-header-icon me-2">show_chart</mat-icon>
                      <span>&nbsp;Token Usage Over Time</span>
                    </div>
                    <div class="card-body p-3">
                      <div style="position: relative; height: 300px;">
                        <canvas #cmdbChart></canvas>
                      </div>
                    </div>
                  </div>
                }

              }
            </div>
          </mat-tab>

        </mat-tab-group>

      </div>
    </div>
  </section>
</main>

<!-- Nora: Action column template -->
<ng-template #actionTemplate let-row>
  @if (row.userId === currentUserId) {
    <button class="button small" (click)="openConversation(row)">View</button>
  }
</ng-template>
